import React from 'react';
import ListLoaderLayout from 'src/components/10-atoms/loaders/ListLoaderLayout';
import { PRESSABLE_SIZE } from 'src/components/10-atoms/pressables/constants';
const SelectLanguageLoader = ({}) => {
    return React.createElement(ListLoaderLayout, { loaderItemHeight: PRESSABLE_SIZE });
};
export default SelectLanguageLoader;
